// extracted by mini-css-extract-plugin
export var absolutePosition = "g_zET";